import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ZenObservable } from 'zen-observable-ts';

import { appConstants } from 'src/app/shared/constants/constants';

import {
  APIService,
  CreateNotificationInput,
  Driver,
  Master,
  UpdateDocumentInput,
  UpdateDriverInput,
  UpdateDriverMutation,
  Document,
  GetArchiveQuery,
} from 'src/app/app-sync.service';
import { DriversService } from '../drivers.service';
import { ModalsService } from 'src/app/shared/modals/modals.service';
import { FeedbacksService } from 'src/app/shared/feedbacks/feedbacks.service';
import { DocumentsService } from 'src/app/pages/documents/documents.service';
import { UsersService } from '../../users/users.service';
import { EditionsService } from '../../../shared/services/editions.service';
import { MasterService } from '../../master/master.service';
import { FormsService } from '../../../shared/services/forms.service';
import { ArchivesService } from '../../../shared/services/archives.service';
import { DocumentFromForms } from '../../../shared/interfaces/document-from-forms';
import { FormValidators } from '../../../shared/interfaces/form-validators';
import { ValidatorsService } from '../../../shared/services/validators.service';
import { CommonsService } from '../../../shared/services/commons.service';
import { ApiRequestsService } from '../../../shared/services/api-requests.service';
import { isReprocesingAvailable } from 'src/app/shared/functions/reprocesing';
import { FeedbackClasses } from 'src/app/shared/interfaces/feedback-classes';

@Component({
  selector: 'app-driver-details',
  templateUrl: './driver-details.component.html',
  styleUrls: ['./driver-details.component.css'],
})
export class DriverDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('driverModal', { static: false }) driverModal:
    | TemplateRef<any>
    | undefined;
  @ViewChild('excludeModal', { static: false }) excludeModal:
    | TemplateRef<any>
    | undefined;
  @ViewChild('archiveDriverModal', { static: false })
  archiveDriverModal: TemplateRef<any> | undefined;
  @ViewChild('updateDriverAttributeModal', { static: false })
  updateDriverAttributeModal: TemplateRef<any> | undefined;
  @ViewChild('driverArchiveDetailsModal', { static: false })
  ArchiveDetailsModal: TemplateRef<any> | undefined;
  @ViewChild('editFuelsAttributesDriverModal', { static: false })
  editFuelsAttributesDriverModal: TemplateRef<any> | undefined;
  @ViewChild('driverArchiveDocumentViewer', { static: false }) documentViewer:
    | TemplateRef<any>
    | undefined;
  driver: Driver;
  driverNeedsApproval: boolean = false;
  driverCanBeRejected: boolean = false;
  showBlockingMotives: boolean = false;
  currentYear: number = new Date().getFullYear();
  currentMonth: number = new Date().getMonth();
  driverAge: number = 0;
  driverInAgeRange: boolean = false;
  isAdmin: boolean = false;
  isApprover: boolean = false;
  isCarrier: boolean = false;
  isBeingRejected: boolean = false;
  isGettingDriver: boolean = false;
  modalMessage: string = '';
  modalQuestion: string = '';
  modalTitle: string = '';
  modalExcludeMessage: string = '';
  modalExcludeQuestion: string = '';
  modalExcludeTitle: string = '';
  modalWithComment: boolean = false;
  archiveForm: FormGroup;
  commentForm: FormGroup;
  exclusionForm: FormGroup;
  updateAttributeForm: FormGroup;
  hasComment: boolean = false;
  showComment: boolean = false;
  master: any = {};
  driverArchive: GetArchiveQuery | undefined;
  isGettingURL: boolean = false;
  pdfSource: string = '';
  business: string = '';

  private selectedDriverChangedSubscription: Subscription = new Subscription();
  private onUpdateDriverListener: ZenObservable.Subscription =
    new Subscription();
  fuelsAttributeForm: FormGroup;
  fuelsValueToEdit: string = '';
  isUnsuscribe: boolean = false;

  constructor(
    private driversService: DriversService,
    private router: Router,
    private route: ActivatedRoute,
    private api: APIService,
    private modalsService: ModalsService,
    private feedbacksService: FeedbacksService,
    private documentsService: DocumentsService,
    private usersService: UsersService,
    private editionsService: EditionsService,
    private masterService: MasterService,
    private formsService: FormsService,
    private validatorsService: ValidatorsService,
    private archivesService: ArchivesService,
    private commonsService: CommonsService,
    private apiRequestsService: ApiRequestsService
  ) {
    this.driver = this.driversService.getSelectedDriver();
    this.archiveForm = new FormGroup({
      motiveForArchiving: new FormControl(null),
      comment: new FormControl(null),
      documents: new FormArray([
        new FormGroup({
          documentMasterValueId: new FormControl(null),
          documentName: new FormControl(null),
          documentIssueDate: new FormControl(null),
          documentExpirationDate: new FormControl(null),
          documentFile: new FormControl(null),
          documentSourceFile: new FormControl(null),
        }),
      ]),
    });
    this.commentForm = new FormGroup({
      comment: new FormControl(null),
    });
    this.exclusionForm = new FormGroup({
      exclusionMotive: new FormControl('', [Validators.required]),
      excludeDuration: new FormControl(null, [Validators.required]),
      isPermanent: new FormControl(false),
      comment: new FormControl(null),
    });
    this.updateAttributeForm = new FormGroup({
      center: new FormControl(null),
    });
    this.fuelsAttributeForm = new FormGroup({
      editableValue: new FormControl(null),
    });
    this.business = this.usersService.business.value.toUpperCase();
  }

  async ngOnInit() {
    this.master = this.masterService.getMaster();

    this.selectedDriverChangedSubscription =
      this.driversService.selectedDriverChanged.subscribe((driver: Driver) => {
        this.driver = driver;
        if (this.driver.archiveId) {
          this.getdriverArchive(this.driver.archiveId);
        }
        this.setDriverSituation();
      });

    this.isAdmin = this.usersService.isAdmin;
    this.isApprover = this.usersService.isApprover;
    this.isCarrier = this.usersService.isCarrier;
    await this.updateSelectedDriver();

    // Subscripción a actualizaciones del conductor
    this.onUpdateDriverListener = this.api
      .OnUpdateDriverListener(
        this.driversService.getSelectedDriverFilterForSubscriptions()
      )
      .subscribe((response) => {
        if (response) {
          this.driversService.refreshSelectedDriver();
        }
      });
  }

  /**
   * Actualiza el conductor seleccionado.
   * @return {Promise}
   * @private
   */
  private async updateSelectedDriver(): Promise<void> {
    this.isGettingDriver = true;
    await this.driversService.refreshSelectedDriver().then(() => {
      this.setDriverSituation();
      this.isGettingDriver = false;
    });
  }

  /**
   * Ejecuta el modal de aprobación de un conductor y pide su
   * actualización en caso de ser aprobado.
   * @return {Promise}
   */
  async onApproveDriver(): Promise<void> {
    this.initCommentForm();
    const driverIdentification = this.commonsService.getIdentification(
      this.driver.sapId!,
      this.driver.firstName + ' ' + this.driver.lastName
    );
    this.modalTitle = appConstants.driver.modalMessages.approve.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.approve.question.replace(
        '_',
        driverIdentification
      );
    this.modalMessage = appConstants.driver.modalMessages.approve.message;
    this.modalWithComment = true;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.driverModal
    );

    if (modalResult) {
      this.isGettingDriver = true;
      await this.updateDriver('approve', this.commentForm.value.comment);
    }
  }

  /**
   * Ejecuta el modal de rechazo de un conductor y pide su
   * actualización en caso de ser rechazado.
   * @return {Promise}
   */
  async onRejectDriver(): Promise<void> {
    this.isBeingRejected = true;
    this.initCommentForm();
    const driverIdentification = this.commonsService.getIdentification(
      this.driver.sapId!,
      this.driver.firstName + ' ' + this.driver.lastName
    );
    this.modalTitle = appConstants.driver.modalMessages.reject.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.reject.question.replace(
        '_',
        driverIdentification
      );
    this.modalMessage = appConstants.driver.modalMessages.reject.message;
    this.modalWithComment = true;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.driverModal
    );

    if (modalResult) {
      this.isGettingDriver = true;
      const newNotification = this.commentForm.value;
      const today = new Date();
      const todayTimestamp = Math.floor(today.getTime() / 1000).toString();
      const creatNotificationInput: CreateNotificationInput = {
        businessId: this.driver.business,
        notificationId: 'DRIVER#' + this.driver.driverId + '#' + todayTimestamp,
        status: 'TO_BE_SENT',
        model: 'DRIVER',
        motive: 'APPROVE#REJECTED',
        driverId: this.driver.driverId,
        comment: newNotification.comment,
      };

      await this.api
        .CreateNotification(creatNotificationInput)
        .then(async () => {
          await this.updateDriver('reject', newNotification.comment);
        });
    }

    this.isBeingRejected = false;
  }

  /**
   * Ejecuta el modal de archivado de un conductor y dirige
   * al componente de edición en caso de ser archivado.
   * @return {Promise}
   */
  async onArchiveDriver(): Promise<void> {
    this.isUnsuscribe = false;
    this.archivesService.setArchiving(true);
    this.initArchiveForm();
    const driverIdentification = this.commonsService.getIdentification(
      this.driver.sapId!,
      this.driver.firstName + ' ' + this.driver.lastName
    );
    this.modalTitle = appConstants.driver.modalMessages.archive.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.archive.question.replace(
        '_',
        driverIdentification
      );
    this.modalMessage = appConstants.driver.modalMessages.archive.message;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.archiveDriverModal
    );

    if (modalResult) {
      console.log(' onArchiveDriver @ driver-details.component ');
      console.log(this.archiveForm.value);
      if (this.archiveForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }

      let documents: DocumentFromForms[] = [];
      if (this.archiveForm.get('documents') !== null) {
        documents = this.archiveForm.value.documents.slice();
      }

      // 1. Se crea el archivo.
      await this.archivesService.createArchive(
        this.driver,
        this.archiveForm.value.motiveForArchiving,
        this.archiveForm.value.comment,
        documents
      );

      // 2. Dirigimos a la creación de la nueva entidad.
      this.router
        .navigate(['../new'], { relativeTo: this.route })
        .then(() => console.log('navigate to new'));
    }
  }

  /**
   * Actualiza un conductor.
   * @param {string} action Acción a realizar, puede ser 'approve' o 'reject'.
   * @param {string} comment Comentario de aprobación o rechazo.
   * @return {Promise}
   * @private
   */
  private async updateDriver(
    action: 'approve' | 'reject',
    comment: string | null = null
  ): Promise<void> {
    this.isGettingDriver = true;
    let newDriverStatus: string;
    let feedbackMessage: string = `Conductor ${this.driver.firstName} ${this.driver.lastName} `;
    let catchFeedbackMessage: string = `Error al _ conductor ${this.driver.firstName} ${this.driver.lastName}`;

    switch (action) {
      case 'approve':
        // Se cambia el estado del conductor a "Procesando"
        newDriverStatus = `${this.driver.business}_${appConstants.entity.codes.inProcess}`;
        feedbackMessage = feedbackMessage + 'aprobado. Actualizando';
        catchFeedbackMessage = catchFeedbackMessage.replace('_', 'aprobar');
        break;
      case 'reject':
        // Se cambia el estado del conductor a "Rechazado"
        newDriverStatus = `${this.driver.business}_${appConstants.entity.codes.rejected}`;
        feedbackMessage = feedbackMessage + 'rechazado. Enviando notificación';
        catchFeedbackMessage = catchFeedbackMessage.replace('_', 'rechazar');
        break;
    }

    const updateDriverInput: UpdateDriverInput = {
      driverId: this.driver.driverId,
      status: newDriverStatus,
      comment: comment,
      updatedBy: this.usersService.getActiveUser().userId,
    };

    await this.api
      .UpdateDriver(updateDriverInput)
      .then(async (driver: UpdateDriverMutation) => {
        this.feedbacksService.showFeedback(feedbackMessage, 'info');

        if (action === 'approve') {
          // Se cambia el estado de los documentos con estado "Por Aprobar"
          // al estado "Procesando"
          for (let document of driver.documents!.items) {
            if (
              document?.status ===
              `${driver.business}_${appConstants.document.codes.toBeApproved}`
            ) {
              const updateDocumentInput: UpdateDocumentInput = {
                documentId: document.documentId,
                name: document.name,
                status: `${driver.business}_${appConstants.document.codes.inProcess}`,
              };
              this.documentsService
                .updateDocument(updateDocumentInput)
                .then(() => console.log('Documento actualizado'));
            }
          }
        }

        // Actualizamos el conductor seleccionado.
        await this.updateSelectedDriver();
      })
      .catch((response: any): void => {
        this.feedbacksService.showErrorFeedbacks(
          response,
          catchFeedbackMessage
        );
      });
  }

  /**
   * Navega al formulario de edición del conductor.
   */
  async onEditDriver(): Promise<void> {
    const editionId: string = `${this.usersService.business.value.toUpperCase()}#DRIVER#${
      this.driver.driverId
    }`;

    if (await this.editionsService.editionIsTaken(editionId)) {
      return;
    }

    this.router
      .navigate(['edit'], { relativeTo: this.route })
      .then(() => console.log('navigate to edit'));
  }

  /**
   * Ejecuta el modal de eliminación de un conductor y lo
   * elimina en caso de aceptar.
   * @return {Promise}
   */
  async onDeleteDriver(): Promise<void> {
    this.modalTitle = appConstants.driver.modalMessages.delete.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.delete.question.replace(
        '_',
        this.driver.sapId!
      );
    this.modalMessage = appConstants.driver.modalMessages.delete.message;
    this.modalWithComment = false;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.driverModal
    );

    if (modalResult) {
      // 1. Se elimina el conductor.
      await this.driversService.deleteDriver(this.driver);

      this.router
        .navigate(['/', this.driver.business.toLowerCase(), 'drivers'])
        .then(() => console.log('navigate to drivers'));
    }
  }
  /**
   * Ejecuta el modal de eliminación de un conductor y lo
   * elimina en caso de aceptar.
   * @return {Promise}
   */
  async onUnsuscribeDriver(): Promise<void> {
    this.isUnsuscribe = true;
    this.initUnsuscribeForm();
    const driverIdentification = this.commonsService.getIdentification(
      this.driver.sapId!,
      this.driver.firstName + ' ' + this.driver.lastName
    );
    this.modalTitle = appConstants.driver.modalMessages.archive.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.archive.question.replace(
        '_',
        driverIdentification
      );
    this.modalMessage = appConstants.driver.modalMessages.archive.message;

    this.modalWithComment = true;
    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.archiveDriverModal
    );

    if (modalResult) {
      let documents: DocumentFromForms[] = [];
      if (this.archiveForm.get('documents') !== null) {
        documents = this.archiveForm.value.documents.slice();
      }

      // 1. Se crea el archivo.
      await this.archivesService.createArchive(
        this.driver,
        this.archiveForm.value.motiveForArchiving,
        this.archiveForm.value.comment,
        documents
      );
      await this.driversService.deleteDriver(this.driver);

      this.router
        .navigate(['/', this.driver.business.toLowerCase(), 'drivers'])
        .then(() => console.log('navigate to drivers'));
    }
  }

  /**
   * Llama a refrescar el conductor seleccionado.
   */
  onRefreshDriver(): void {
    this.updateSelectedDriver().then(() =>
      console.log('Conductor seleccionado actualizado.')
    );
  }

  /**
   * Colapsa o muestra el comentario del vehículo.
   */
  onViewComment(): void {
    this.showComment = !this.showComment;
  }

  /**
   * Ejecuta el modal de edición de atributos del conductor.
   * @return {Promise}
   */
  async onUpdateDriver(): Promise<void> {
    this.initUpdateAttributeForm();

    this.modalTitle = appConstants.driver.modalMessages.edit.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.edit.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.driver.sapId!,
          this.driver.firstName + ' ' + this.driver.lastName
        )
      );
    this.modalMessage = appConstants.driver.modalMessages.edit.message;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.updateDriverAttributeModal
    );

    if (modalResult) {
      if (this.updateAttributeForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }

      const patchedCisterna = this.updateAttributeForm.value;
      const payload: { [key: string]: string } = {
        center: patchedCisterna.center,
      };

      this.apiRequestsService.updateEntity(
        this.driver.business,
        this.driver.__typename,
        this.commonsService.getIdentification(
          this.driver.sapId!,
          this.driver.driverId +
            ' - ' +
            this.driver.firstName +
            ' ' +
            this.driver.lastName
        ),
        payload
      );
    }
  }

  /**
   * Retorna la clase que colapsa o muestra el comentario del vehículo.
   * @return {string} Clase CSS
   */
  showCommentClass(): string {
    return this.showComment ? 'show' : '';
  }

  /**
   * Inicializa el formulario de rechazo de un conductor.
   * @private
   */
  private initCommentForm(): void {
    // Inicialización del formulario
    this.commentForm = this.formsService.generateCommentForm(
      this.isBeingRejected
    );
  }

  /**
   * Inicializa el formulario de archivado de un conductor.
   * @private
   */
  private initArchiveForm(): void {
    let documents: Master[] = [];
    let validators: { [key: string]: FormValidators } = {};

    // El negocio Externos exige una carta aclaratoria para archivar.
    if (this.driver.business === 'FOREIGN') {
      // Agregamos la Carta Aclaratoria
      const index = this.master[`ARCHIVES#DOCUMENT_TYPES`].findIndex(
        (document: any): boolean => {
          return (
            document.valueId ===
            `${this.driver.business}_${appConstants.document.codes.explanatory_letter}`
          );
        }
      );
      const document: Master = this.master['ARCHIVES#DOCUMENT_TYPES'][index];
      documents.push(document);

      validators = {
        [document.valueId]: this.validatorsService.getDocumentValidatorForm(
          this.driver.center,
          true
        ),
      };
    }

    // Inicialización del formulario
    this.archiveForm = this.formsService.generateArchiveForm(
      documents,
      validators
    );
  }
  private initUnsuscribeForm(): void {
    let documents: Master[] = [];
    let validators: { [key: string]: FormValidators } = {};
    // Agregamos finiquito como unico documento.
    const index = this.master[`ARCHIVES#DOCUMENT_TYPES`].findIndex(
      (document: any): boolean => {
        return (
          document.valueId ===
          `${this.driver.business}_${appConstants.document.codes.termination}`
        );
      }
    );
    const document: Master = this.master['ARCHIVES#DOCUMENT_TYPES'][index];
    documents.push(document);

    validators = {
      [document.valueId]: this.validatorsService.getDocumentValidatorForm(
        this.driver.center,
        true
      ),
    };
    // Inicialización del formulario
    this.archiveForm = this.formsService.generateArchiveForm(
      documents,
      validators
    );
  }

  /**
   * Inicializa el formulario de actualización de
   * atributos de un conductor.
   * @private
   */
  private initUpdateAttributeForm(): void {
    // Inicialización del formulario
    this.updateAttributeForm = new FormGroup({
      center: new FormControl(this.driver.center, [Validators.required]),
    });
  }

  /**
   * Indica si un conductor tiene documentos por vencer.
   * @return {boolean} Boolean que indica si el conductor tiene documentos por vencer.
   */
  hasToExpireDocuments(): boolean {
    const docNumber = this.driver.documentsToExpire || 0;
    return docNumber > 0;
  }

  /**
   * Indica si un conductor tiene documentos vencidos.
   * @return {boolean} Boolean que indica si el conductor tiene documentos vencidos.
   */
  hasExpiredDocuments(): boolean {
    const docNumber = this.driver.documentsExpired || 0;
    return docNumber > 0;
  }

  /**
   * Retorna una clase CSS dependiendo de la edad del Conductor.
   * @return {string}
   */
  driverAgeClass(): string {
    return this.driverInAgeRange ? '' : 'text-danger';
  }

  /**
   * Retorna un color dependiendo del estado del envasado.
   * @return {string}
   */
  getColor(): string {
    return this.masterService.getSatusColor(this.driver.status);
  }

  /**
   * Retorna la fuente de imagen a mostrar en el Estado del envasado.
   * @return {string} ruta a imagen.
   */
  getImageSrc(status: string): string {
    return this.masterService.getImageSrc(status);
  }

  /**
   * Determina, con base al rol del usuario, cuáles botones mostrar.
   * @param {string} button Acción del botón.
   */
  showButton(button: string): boolean {
    let show: boolean = false;

    switch (button) {
      case 'delete':
      case 'archive':
        show = this.isAdmin;
        break;
      case 'approve':
      case 'reject':
        show = this.isAdmin || this.isApprover;
        break;
      case 'actions':
        show = this.isAdmin || this.isCarrier || this.isApprover;
        break;
      case 'edit':
        show = this.isAdmin || this.isCarrier;
        break;
      case 'block':
        show = (this.isAdmin || this.isApprover) && !this.checkBlockMotives();
        break;
      case 'unlock':
        show = (this.isAdmin || this.isApprover) && this.checkBlockMotives();
        break;
      case 'edit-center':
        show = this.isAdmin && this.driver.business === 'LUBRICANTS';
        break;
      default:
        break;
    }
    return show;
  }

  /**
   * Define la situación del conductor: ¿necesita aprobación?, ¿puede ser rechazado?,
   * ¿Está bloqueado?
   */
  private setDriverSituation(): void {
    const driverToBeApprove: boolean =
      this.driver.status ===
      `${this.driver.business}_${appConstants.entity.codes.toBeApproved}`;
    const driverRejected: boolean =
      this.driver.status ===
      `${this.driver.business}_${appConstants.entity.codes.rejected}`;
    const birthYear: number = new Date(
      this.driver.birthDate || ''
    ).getFullYear();
    const birthMonth: number = new Date(this.driver.birthDate || '').getMonth();

    this.driverNeedsApproval = driverToBeApprove || driverRejected;
    this.driverCanBeRejected = driverToBeApprove;
    this.showBlockingMotives =
      this.driver.blockingMotives !== null &&
      this.driver.blockingMotives !== undefined &&
      this.driver.blockingMotives.length > 0 &&
      this.driver.status !==
        `${this.driver.business}_${appConstants.entity.codes.available}`;
    this.hasComment = !!this.driver.comment;
    this.showComment = false;
    this.driverAge = this.currentYear - birthYear;
    // Si aún no llegamos al mes de nacimiento, se resta un año
    if (this.currentMonth < birthMonth) {
      this.driverAge -= 1;
    }

    // El conductor debe tener entre 25 y 70 años.
    this.driverInAgeRange =
      appConstants.driver.age.min <= this.driverAge &&
      this.driverAge <= appConstants.driver.age.max;
  }

  /**
   *
   */
  async onExcludeDriver(): Promise<void> {
    this.exclusionForm.reset();
    const driverIdentification = this.commonsService.getIdentification(
      this.driver.sapId!,
      this.driver.firstName + ' ' + this.driver.lastName
    );
    this.modalExcludeMessage =
      appConstants.driver.modalMessages.exclude.message;
    this.modalExcludeQuestion =
      appConstants.driver.modalMessages.exclude.question.replace(
        '_',
        driverIdentification
      );
    this.modalExcludeTitle = appConstants.driver.modalMessages.exclude.title;
    let feedbackMessage: string = `Conductor ${this.driver.firstName} ${this.driver.lastName} bloqueado con éxito.`;
    let errorFeedbackMessage: string = `Conductor ${this.driver.firstName} ${this.driver.lastName} no pudo ser bloqueado. `;
    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.excludeModal
    );
    // respuesta afirmativa y valida del formulario
    if (modalResult) {
      let newDriverStatus = `${this.driver.business}_${appConstants.entity.codes.inProcess}`;
      const updateDriverInput: UpdateDriverInput = {
        driverId: this.driver.driverId,
        status: newDriverStatus,
        updatedBy: this.usersService.getActiveUser().userId,
      };
      let today = new Date().toISOString().split('T')[0];
      this.api
        .CreateDriverExclusion({
          driverId: this.driver.driverId,
          startDate: today,
          endDate: this.exclusionForm.value.isPermanent
            ? '2100-12-21'
            : this.exclusionForm.value.excludeDuration,
          exclusionMotives: this.exclusionForm.value.exclusionMotive,
          comment: this.exclusionForm.value.comment,
        })
        .then(async () => {
          await this.api.UpdateDriver(updateDriverInput).then(async () => {
            this.feedbacksService.showFeedback(feedbackMessage, 'info');
            await this.updateSelectedDriver();
          });
        })
        .catch((error) => {
          this.feedbacksService.showErrorFeedbacks(error, errorFeedbackMessage);
          console.error(error);
        });
    }
  }

  /**
   *
   */
  async onUnlockDriver(): Promise<void> {
    //config modal
    this.modalTitle = appConstants.driver.modalMessages.unlock.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.unlock.question.replace(
        '_',
        `${this.driver.sapId!} - ${this.driver.firstName} ${
          this.driver.lastName
        }`
      );
    this.modalMessage = appConstants.driver.modalMessages.unlock.message;
    this.modalWithComment = false;
    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.driverModal
    );
    // Configuración para el servicio.
    let newDriverStatus = `${this.driver.business}_${appConstants.entity.codes.inProcess}`;
    const updateDriverInput: UpdateDriverInput = {
      driverId: this.driver.driverId,
      status: newDriverStatus,
      comment: '',
      updatedBy: this.usersService.getActiveUser().userId,
    };
    let feedbackMessage: string = `Conductor ${this.driver.firstName} ${this.driver.lastName} desbloqueado con éxito.`;
    let errorFeedbackMessage: string = `Conductor ${this.driver.firstName} ${this.driver.lastName} no pudo ser desbloqueado. `;
    // se acepta el modal y se llama a los servicios
    if (modalResult) {
      this.api
        .DeleteDriverExclusion({
          driverId: this.driver.driverId,
        })
        .then(async () => {
          await this.api.UpdateDriver(updateDriverInput).then(async () => {
            this.feedbacksService.showFeedback(feedbackMessage, 'info');
            await this.updateSelectedDriver();
          });
        })
        .catch((error) => {
          this.feedbacksService.showErrorFeedbacks(error, errorFeedbackMessage);
          console.error(error);
        });
    }
  }

  checkBlockMotives(): boolean {
    return (
      this.driver.blockingMotives?.some(
        (blockMotiveDriver) => blockMotiveDriver === 'Lista de Exclusión'
      ) || false
    );
  }
  /**
   *
   */
  getdriverArchive(archiveId: string) {
    this.archivesService.getArchiveById(archiveId).then((archivo) => {
      this.driverArchive = archivo;
    });
  }
  /**
   * Ejecuta el modal de detalles archivo
   */
  async onViewArchiveDetails() {
    await this.modalsService.showModal(
      <TemplateRef<any>>this.ArchiveDetailsModal
    );
  }

  async onDownloadArchiveDocument(): Promise<void> {
    let document: Document = appConstants.document.initialization;
    if (this.driverArchive) {
      document.name = `Documento Archivo - ${this.driverArchive.modelTypeName}`;
      document.s3Path = this.driverArchive.documents?.items[0]?.s3Path || '';
      document.archiveDocumentsArchiveId = this.driverArchive.archiveId;
      this.documentsService.setSelectedModel('ARCHIVE');
    }
    await this.documentsService.downloadDocument(document);
  }
  /**
   * Abre el modal de visualización de un documento.
   * @return {Promise}
   */
  async onViewDocumentArchive(): Promise<void> {
    this.isGettingURL = true;
    let document: Document = appConstants.document.initialization;

    this.modalTitle = 'Documento de Archivo';
    document.name = this.modalTitle;
    document.s3Path = this.driverArchive?.documents?.items[0]?.s3Path || '';

    await this.documentsService
      .getDocumentPreSignedURL(document)
      .then(async (): Promise<void> => {
        this.pdfSource = this.documentsService.documentPreSignedURL;
        await this.modalsService.showModal(
          <TemplateRef<any>>this.documentViewer,
          true
        );
      });
  }
  pageRendered(): void {
    this.isGettingURL = false;
  }

  hasDocumentOnArchive(): boolean {
    return this.driverArchive?.documents?.items[0]?.s3Path ? true : false;
  }

  OnReprocesiing(): void {
    if (!this.isAdmin && !this.isReprocesingAvailable()) {
      return;
    }
    this.isGettingDriver = true;
    this.api
      .UpdateDriver({
        driverId: this.driver.driverId,
        status: `${this.driver.business}_${appConstants.entity.codes.toBeApproved}`,
      })
      .then((response) => {
        console.log(response);
        this.api.UpdateDriver({
          driverId: this.driver.driverId,
          status: `${this.driver.business}_${appConstants.entity.codes.inProcess}`,
        });
        this.isGettingDriver = false;
      });
  }

  isReprocesingAvailable(): boolean {
    if (this.driver.status.endsWith('_0000004')) {
      return isReprocesingAvailable(this.driver.updatedAt);
    }
    return false;
  }

  async onUpdateFuelsAttributesDriver(valueToEdit: string): Promise<void> {
    this.fuelsValueToEdit = valueToEdit;
    this.initFormFuelsAttributes();

    this.modalTitle = appConstants.driver.modalMessages.edit.title;
    this.modalQuestion =
      appConstants.driver.modalMessages.edit.question.replace(
        '_',
        this.commonsService.getIdentification(
          this.driver.sapId!,
          this.driver.firstName + ' ' + this.driver.lastName
        )
      );
    this.modalMessage = appConstants.driver.modalMessages.edit.message;

    let modalResult: boolean = await this.modalsService.showModal(
      <TemplateRef<any>>this.editFuelsAttributesDriverModal
    );

    if (modalResult) {
      if (this.fuelsAttributeForm.invalid) {
        this.feedbacksService.showFeedback(
          'Formulario inválido, no será procesada la petición.',
          'danger'
        );
        return;
      }
      let UpdateDriverInput: UpdateDriverInput = {
        driverId: this.driver.driverId,
      };
      switch (this.fuelsValueToEdit) {
        case 'accreditationType':
          UpdateDriverInput.accreditationType =
            this.fuelsAttributeForm.value.editableValue;
          break;
        case 'assignmentType':
          UpdateDriverInput.assignmentType =
            this.fuelsAttributeForm.value.editableValue;
          break;
        case 'group':
          UpdateDriverInput.group = this.fuelsAttributeForm.value.editableValue;
          break;
      }
      this.api
        .UpdateDriver(UpdateDriverInput)
        .then((res) => {
          let feedbackMessage = `Éxito actualizando Conductor: ${this.driver.firstName} ${this.driver.lastName}.`;
          let feedbackType: keyof FeedbackClasses = 'success';
          this.feedbacksService.showFeedback(feedbackMessage, feedbackType);
        })
        .catch((error) => {
          let feedbackMessageType: 'info' | 'danger' = 'danger';
          let feedbackMessage =
            'Error al actualizar  Conductor error: ' + error;
          this.feedbacksService.showFeedback(
            feedbackMessage,
            feedbackMessageType
          );
        });
    }
  }

  private initFormFuelsAttributes(): void {
    // Inicialización del formulario
    const initialValue = this.driver[this.fuelsValueToEdit as keyof Driver];
    this.fuelsAttributeForm = new FormGroup({
      editableValue: new FormControl(initialValue, Validators.required),
    });
  }

  ngOnDestroy(): void {
    this.selectedDriverChangedSubscription.unsubscribe();
    this.onUpdateDriverListener.unsubscribe();
    console.log('driver-details.component subscriptions removed.');
  }
}
